import VisitorCRUDActions from '../actions/VisitorCRUDActions';

type ActionType = {
  type: string;
  entity: { visitorId: string };
};

const initialState = {};

export const visitor = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case VisitorCRUDActions.retrieveData:
      return { ...state, ...action.entity };
    default:
      return state;
  }
};
